/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  PayLeverageGetAccruedInterestOptions,
  PayLeverageGetAccruedInterestResponses,
} from '../types/PayLeverageGetAccruedInterest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Pay current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/pay}
 */
export function payLeverageGetAccruedInterest<ThrowOnError extends boolean = true>(
  options: Options<PayLeverageGetAccruedInterestOptions, ThrowOnError>,
): Unwrappable<RequestResult<PayLeverageGetAccruedInterestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/leverage/accrued_interest/pay',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<PayLeverageGetAccruedInterestResponses, ThrowOnError>>,
  )
}
